export default {
    inserted(el, binding, vnode) {
        // 获取element-ui定义好的scroll盒子
        const SELECTDOWN_DOM = el.querySelector(
            '.el-select-dropdown .el-select-dropdown__wrap'
        )

        SELECTDOWN_DOM.addEventListener('scroll', function () {
            const CONDITION =
                parseInt(this.scrollHeight - this.scrollTop) <= this.clientHeight
            if (CONDITION) {
                binding.value()
            }
        })
    }
}